import * as THREE from 'three';
import * as TWEEN from 'tween.js';

import Config from '../config';
import * as CountryDataHelpers from '../utils/countryDataHelpers';
import { transformSVGPath } from '../three/d3-threeD';
import { log } from '../LogTerminal';

// import { find } from 'lodash';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function roundRect(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r); ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h); ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r); ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y); ctx.closePath(); ctx.fill(); ctx.stroke(); }

function createText(message, parameters ) {
    if ( parameters === undefined ) parameters = {};
    var fontface = parameters.hasOwnProperty("fontface") ? parameters["fontface"] : '"GEOG-regular", Arial, sans-serif';
    var fontsize = parameters.hasOwnProperty("fontsize") ? parameters["fontsize"] : 50;
    var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters["borderThickness"] : 40;
    var borderColor = parameters.hasOwnProperty("borderColor") ?parameters["borderColor"] : { r:0, g:0, b:0, a:0.0 };
    var backgroundColor = parameters.hasOwnProperty("backgroundColor") ?parameters["backgroundColor"] : { r:0, g:154, b:205, a:1 };
    var textColor = parameters.hasOwnProperty("textColor") ?parameters["textColor"] : { r:255, g:255, b:255, a:1.0 };

    var canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 128;
    var context = canvas.getContext('2d');
    context.font = fontsize + "px " + fontface;
    var metrics = context.measureText( message );
    var textWidth = metrics.width;

    context.fillStyle   = "rgba(" + backgroundColor.r + "," + backgroundColor.g + "," + backgroundColor.b + "," + backgroundColor.a + ")";
    context.strokeStyle = "rgba(" + borderColor.r + "," + borderColor.g + "," + borderColor.b + "," + borderColor.a + ")";

    context.lineWidth = borderThickness;
    roundRect(context, borderThickness/2, borderThickness/2, (metrics.width < 80 ) ? 80 : 120, 80, 50); //(textWidth + borderThickness) * 1.1, fontsize * 1.4 + borderThickness

    context.fillStyle = "rgba("+textColor.r+", "+textColor.g+", "+textColor.b+", 1.0)";
    let x =(message < 10) ? borderThickness + 5 : ((message >= 10 && message < 100) ? borderThickness - 10 : borderThickness);
    context.fillText( message, x, fontsize + borderThickness - 10);

    var texture = new THREE.Texture(canvas);
    texture.needsUpdate = true;

    var spriteMaterial = new THREE.SpriteMaterial( { map: texture } );
    var sprite = new THREE.Sprite( spriteMaterial );
    sprite.scale.set(0.5 * fontsize, 0.25 * fontsize, 0.75 * fontsize);
    sprite.position.x = -5;
    sprite.position.y = 5;
    sprite.position.z = (message < 100) ? -7 : -5;

    return sprite;  
}

function Marker(color = 0) {
  var group = new THREE.Group();
  var radius = 0.4;
  var sphereRadius = 0.6;
  var height = 3;
  if(color == 0) {
    let rand = getRandomInt(0, 1);
    color = Config.pinColors[rand];
  }
  var material = new THREE.MeshPhongMaterial({
    color: color,
    transparent: false,
    wireframe: false,
    shading: THREE.SmoothShading,
    side: THREE.DoubleSide,
    overdraw: true
  });

  var cone = new THREE.Mesh(new THREE.ConeGeometry(radius, height, 8, 1, true), material);
  cone.position.y = height * 0.45;
  cone.rotation.x = Math.PI;
  cone.name = "cone";

  var sphere = new THREE.Mesh(new THREE.SphereGeometry(sphereRadius, 16, 8), material);
  sphere.position.y = height * 0.8 + sphereRadius;
  sphere.name = "conepin";

  group.add(cone, sphere);
  return group;
}

function createMarkerLatLon(lat, lon, type) {
  var marker = Marker(Config.pinColors[type]);

  var latRad = lat * (Math.PI / 180);
  var lonRad = -lon * (Math.PI / 180);
  var r = Config.globeRadius;

  let check = (Math.cos(latRad) * Math.cos(lonRad) * r)+', '+(Math.sin(latRad) * r)+', '+(Math.cos(latRad) * Math.sin(lonRad) * r);
  if(check == '1, 0, 0' || check == 'NaN, NaN, NaN') return false;

  marker.position.set(Math.cos(latRad) * Math.cos(lonRad) * r, Math.sin(latRad) * r, Math.cos(latRad) * Math.sin(lonRad) * r);
  marker.rotation.set(0.0, -lonRad, latRad - Math.PI * 0.5);
  marker.visible = false;

  return marker;
}

function createMarkerCenter(lat, lon, text) {
  var pin = new THREE.Object3D();
  pin['marker'] = Marker();
  pin['text'] = createText(text);

  pin.add(pin['marker'], pin['text']);

  var latRad = lat * (Math.PI / 180);
  var lonRad = -lon * (Math.PI / 180);
  var r = 180;

  let check = (Math.cos(latRad) * Math.cos(lonRad) * r)+', '+(Math.sin(latRad) * r)+', '+(Math.cos(latRad) * Math.sin(lonRad) * r);
  if(check == '1, 0, 0' || check == 'NaN, NaN, NaN') return false;

  pin.position.set(Math.cos(latRad) * Math.cos(lonRad) * r, Math.sin(latRad) * r, Math.cos(latRad) * Math.sin(lonRad) * r);
  pin.rotation.set(0.0, -lonRad, latRad - Math.PI * 0.5);
  pin.name = "pin";
  pin.visible = false; 

  return pin;
}

function createMarkerXYZ(position) {
  var marker = Marker();

  marker.position.set(position);
  marker.visible = true;

  return marker;
}

export function createCountriesGeometry(worldMap) {
  var data = worldMap.dataCountries;
  var start = Date.now();

  worldMap.countriesObject3D = new THREE.Object3D();
  worldMap.pinObject3D = new THREE.Object3D();
  worldMap.countries = [];
  worldMap.trianglesNumTotal = 0;
  worldMap.countryDropdownChoices = [];

  
  var pinInfo = pinJSON;
  let pinObj = {};
  for(const pin of pinInfo) {
    let country = pin.country;

    if(!pinObj.hasOwnProperty(country)) {
      pinObj[country] = [];
    }

    if(!worldMap.cityList.hasOwnProperty(country)) {
      worldMap.cityList[country] = [];
    }

    pinObj[country].push(pin);
    if(!worldMap.cityList[country].includes(pin.city)) worldMap.cityList[country].push(pin.city);
  }
  pinJSON = null;
  pinInfo = null;

  var centerInfo = countryLatLonJSON;
  let centerObj = {};
  for(const pin of centerInfo) {
    let country = pin.name;

    centerObj[country] = pin;
  }
  countryLatLonJSON = null;
  centerInfo = null;

  // features = countries
  var i;
  for(i = 0; i < data.features.length; i++) {
    var feature = data.features[i];
    
    if(feature.disputed) continue;

     //  && feature.properties.name === 'Germany'
      // convert SVG data to three.js Shapes array (all shapes in one country):
      
      var t = worldMap.geo.path(feature);

      if(t !== undefined) {
        var shapes = transformSVGPath( t );

        //creo array coi pin
        let pinArray = [];
        if(pinObj.hasOwnProperty(feature.properties.NAME_EN)) {
          for(let pin of pinObj[feature.properties.NAME_EN]){
            let marker = createMarkerLatLon(pin.lat, pin.lon, pin.type);
            if(marker) {
              marker.name = pin.name;
              marker.info = pin;
              pinArray.push({marker: marker, info: pin});
              worldMap.pinObject3D.add(marker);
              worldMap.globe.add(marker);
            }
          }

          pinArray.sort((a,b) => (a.info.name > b.info.name) ? 1 : ((b.info.name > a.info.name) ? -1 : 0));
        }

        //creo pin centrale
        var centerMarker;
        if(centerObj.hasOwnProperty(feature.properties.NAME_EN) && pinArray.length > 0) {
          centerMarker = createMarkerCenter(centerObj[feature.properties.NAME_EN].lat, centerObj[feature.properties.NAME_EN].lon, pinArray.length);
          if(centerMarker) {
            centerMarker.marker.name = centerObj[feature.properties.NAME_EN].name;
            centerMarker.marker.scale.set(1.5,1.5,1.5);
            worldMap.centerPins.push(centerMarker);
            worldMap.globe.add(centerMarker);
          }
        }

        let colorN = Math.ceil((pinArray.length * 10) / 280);

        
        if(worldMap.saceData.countries[feature.properties.WB_A2.toLowerCase()] != undefined) {
          var opportunity = worldMap.saceData.countries[feature.properties.WB_A2.toLowerCase()].exp;
          var risk = worldMap.saceData.countries[feature.properties.WB_A2.toLowerCase()].risk;
          var opportunityColor = Math.round(worldMap.saceData.countries[feature.properties.WB_A2.toLowerCase()].exp.coloridx / 10);
          var riskColor = Math.round(worldMap.saceData.countries[feature.properties.WB_A2.toLowerCase()].risk.coloridx / 10);
        }

        var country = {
          name: feature.properties.NAME_EN,
          nameSort: feature.properties.NAME_SORT,
          sovereignt: feature.properties.SOVEREIGNT,
          brkName: feature.properties.BRK_NAME, // in disputed areas
          noteBrk: feature.properties.NOTE_BRK, // in disputed areas
          type: 'Country',
          postal: feature.properties.WB_A2.toLowerCase(),
          disputed: feature.disputed === true,
          pinArray: pinArray,
          pinVisible: false,
          pinCenter: centerMarker,

          properties: feature.properties,
          shapes,
          destinations: [],
          numDestinationsFreeOrOnArrival: 0,
          numSourcesFreeOrOnArrival: 0,
          opportunity: opportunity,
          risk: risk,
          opportunityColor: new THREE.Color(Config.colorCountryArrayOpportunity[opportunityColor]),
          riskColor: new THREE.Color(Config.colorCountryArrayRisk[riskColor]),
          color: new THREE.Color(Config.colorCountryArrayDefault[colorN]),
          colorLast: new THREE.Color(Config.colorCountryArrayDefault[colorN])
        };

        /* if(country.disputed) {
          country.name = country.brkName === country.name
            ? country.name + ' (' + country.type + ')'
            : country.name + '/' + country.brkName + ' (' + country.type + ')';
        } */


        worldMap.countries.push(country);

        // if(country.destinations.length === 0) {
        //   console.error('Geometry: No visa requirements found for: ' + country.name);
        // }

        /* if(!country.disputed) {
          countriesUsed.push(country.name);

          if(CountryDataHelpers.isCountry(country)) {
            worldMap.countryDropdownChoices.push({text: country.name, value: country.name});
          } else {
            worldMap.countryDropdownChoices.push({text: country.name + ' (' + country.sovereignt + ')', value: country.name});
          }
        } */

        // log("Geometry" + country.name + " | shapes: " + shapes.length + ", total points: " + pointCount);

      }
    
  }

  pinObj = null;
  centerObj = null;

  /* worldMap.countries.sort((a, b) => {
    var aName = a.name.toLowerCase();
    var bName = b.name.toLowerCase();
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
  }); */

  // console.log(JSON.stringify(countriesUsed.sort()));

  // console.log(worldMap.countries);

  // console.log(find(worldMap.countries, (c) => c.name === 'China'));

  // Add countries that didn't exist in geojson:
  // for(r = 0; r < worldMap.visaRequirements.countries.length; r++) {
  //   if(!find(worldMap.countries, (c) => {
  //     return c.name === worldMap.visaRequirements.countries[r].name ||
  //     c.sovereignt === worldMap.visaRequirements.countries[r].name
  //     ;
  //   })) {
  //     console.log(worldMap.visaRequirements.countries[r]);
  //   }
  // }

  //var d;
  // var country;
  // var countriesString = '';
  // remove destinations who's country doesn't exist:
  /* for(i = 0; i < worldMap.countries.length; i++) {
    destinations = worldMap.countries[i].destinations;
    var destinationsNew = [];
    for(d = 0; d < destinations.length; d++) {
      country = CountryDataHelpers.getCountryByName(worldMap.countries, destinations[d].d_name);
      if(country !== null) {
        destinationsNew.push(destinations[d]);
      }
    }
    worldMap.countries[i].destinations = destinationsNew;

    // countriesString += (i + 1) + ' ' + worldMap.countries[i].name;
    // if(i < worldMap.countries.length - 1) {
    //   countriesString += '\n';
    // }

  } */
  // console.log(countriesString);

  /* worldMap.countryDropdownChoices.sort((a, b) => {
    var aName = a.text.toLowerCase();
    var bName = b.text.toLowerCase();
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
  }); */

  // log('Max number of visa-free destinations: ' + worldMap.maxNumDestinationsFreeOrOnArrival);
  // log('Max number of visa-free sources: ' + worldMap.maxNumSourcesFreeOrOnArrival);
  // log('Total population: ' + worldMap.totalPopulation.formatNumber(0));

  var m = new THREE.Matrix4();
  var m1 = new THREE.Matrix4();
  var m2 = new THREE.Matrix4();
  m1.makeRotationX( Config.globeRotationX );
  m2.makeRotationY( Config.globeRotationY );
  m.multiplyMatrices( m1, m2 );

  for(i = 0; i < worldMap.countries.length; i++) {
    if(Config.extrudeEnabled) {
      // create extruded geometry from path Shape:
      worldMap.countries[i].geometry = new THREE.ExtrudeGeometry( worldMap.countries[i].shapes, {
        // amount: Config.extrudeDepth * 10,
        // amount: 0.5 + worldMap.getPopulationRatio(worldMap.countries[i].properties) * 100,
        amount: worldMap.countries[i].numDestinationsFreeOrOnArrival / worldMap.maxNumDestinationsFreeOrOnArrival * 100,
        bevelEnabled: false
      } );
    } else {
      // create flat ShapeGeometry from path Shape:
      worldMap.countries[i].geometry = new THREE.ShapeGeometry( worldMap.countries[i].shapes );
    }

    // subtesselate surface:
    if(Config.tesselationEnabled) {
      var tessellateModifier = new THREE.TessellateModifier( Config.tesselationMaxEdgeLength ); // 2
      for( var n = 0; n < Config.tesselationIterations; n++ ) { // 10
        tessellateModifier.modify( worldMap.countries[i].geometry );
      }
    }

    // 2D Geometry:
    var k;
    worldMap.countries[i].geometry2D = worldMap.countries[i].geometry.clone();
    for(k = 0; k < worldMap.countries[i].geometry2D.vertices.length; k++) {
      worldMap.countries[i].geometry2D.vertices[k].x += Config.mapOffsetX;
      worldMap.countries[i].geometry2D.vertices[k].y = -worldMap.countries[i].geometry2D.vertices[k].y + Config.mapOffsetY;
      /* if(worldMap.countries[i].disputed) {
        // draw disputed areas on top:
        worldMap.countries[i].geometry2D.vertices[k].z += 0.1;
      } */
    }

    worldMap.trianglesNumTotal += worldMap.countries[i].geometry.faces.length;

    // 2D points meshes (for showing country border on hover):
    worldMap.countries[i].border2D = new THREE.Object3D();
    //worldMap.countries[i].borderDisputed2D = new THREE.Object3D();
    worldMap.countries[i].center2D = new THREE.Vector3();
    var vertexCount = 0;
    for(var s = 0; s < worldMap.countries[i].shapes.length; s++) {
      var pointsGeometry = worldMap.countries[i].shapes[s].createPointsGeometry();
      for(k = 0; k < pointsGeometry.vertices.length; k++) {
        pointsGeometry.vertices[k].x += -1 * Config.mapOffsetX;
        pointsGeometry.vertices[k].y = pointsGeometry.vertices[k].y + Config.mapOffsetY;
        pointsGeometry.vertices[k].z += 0.1;

        worldMap.countries[i].center2D.add(pointsGeometry.vertices[k]);
        vertexCount++;
      }
      worldMap.countries[i].border2D.add(new THREE.Line( pointsGeometry, Config.materialCountryBorder ));

    }
    worldMap.countries[i].center2D.divideScalar(vertexCount);
    CountryDataHelpers.correctCenter(worldMap.countries[i]);


    // 2D points meshes (for disputed country border, always visible):
    /* if(worldMap.countries[i].disputed) {
      worldMap.countries[i].borderDisputed2D = new THREE.Object3D();
      for(s = 0; s < worldMap.countries[i].shapes.length; s++) {
        pointsGeometry = worldMap.countries[i].shapes[s].createPointsGeometry();
        for(k = 0; k < pointsGeometry.vertices.length; k++) {
          pointsGeometry.vertices[k].x += Config.mapOffsetX;
          pointsGeometry.vertices[k].y = -pointsGeometry.vertices[k].y + Config.mapOffsetY;
          pointsGeometry.vertices[k].z += 0.15;
        }
        worldMap.countries[i].borderDisputed2D.add(new THREE.Line( pointsGeometry, Config.materialCountryBorderDisputed ));
      }
    } */


    // 3D Geometry:
    worldMap.countries[i].geometry3D = worldMap.countries[i].geometry.clone();
    for(k = 0; k < worldMap.countries[i].geometry.vertices.length; k++) {
      var spherical = worldMap.geo.projection.invert([worldMap.countries[i].geometry.vertices[k].x, worldMap.countries[i].geometry.vertices[k].y]);
      spherical[0] = THREE.Math.degToRad(spherical[0]);
      spherical[1] = THREE.Math.degToRad(spherical[1]);

      // worldMap.countries[i].geometry3D.vertices[k].x = Config.globeRadius * Math.cos(spherical[0]) * Math.cos(spherical[1]);
      // worldMap.countries[i].geometry3D.vertices[k].y = - Config.globeRadius * Math.sin(spherical[1]);
      // worldMap.countries[i].geometry3D.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);

      worldMap.countries[i].geometry3D.vertices[k].x = -1 * Config.globeRadius * Math.cos(spherical[0]) * Math.cos(spherical[1]);
      worldMap.countries[i].geometry3D.vertices[k].y = Config.globeRadius * Math.sin(spherical[1]);
      if(worldMap.countries[i].geometry.vertices[k].z < Config.extrudeDepth) {
        worldMap.countries[i].geometry3D.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);
        // worldMap.countries[i].geometry3D.vertices[k].multiplyScalar(0.5);
        /* if(worldMap.countries[i].disputed) {
          // draw disputed areas on top:
          worldMap.countries[i].geometry3D.vertices[k].multiplyScalar(1.0005);
        } */
      } else {
        worldMap.countries[i].geometry3D.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);
        worldMap.countries[i].geometry3D.vertices[k].multiplyScalar(1.002);
        if(Config.extrudeEnabled) {
          worldMap.countries[i].geometry3D.vertices[k].multiplyScalar( 1 + worldMap.countries[i].numDestinationsFreeOrOnArrival / worldMap.maxNumDestinationsFreeOrOnArrival * 0.5);
        }
      }
    }
    // rotate and bake transform into vertices:
    //worldMap.countries[i].geometry3D.applyMatrix(m);

    worldMap.countries[i].center3D = new THREE.Vector3();
    vertexCount = 0;
    for(k = 0; k < worldMap.countries[i].geometry3D.vertices.length; k++) {
      worldMap.countries[i].center3D.add(worldMap.countries[i].geometry3D.vertices[k]);
      vertexCount++;
    }
    worldMap.countries[i].center3D.divideScalar(vertexCount);

    //worldMap.countries[i].pinCenter = createMarkerXYZ(worldMap.countries[i].center3D);

    // worldMap.countries[i].center3D.copy(worldMap.countries[i].center2D);
    /* spherical = worldMap.geo.projection.invert([worldMap.countries[i].center2D.x - Config.mapOffsetX, -worldMap.countries[i].center2D.y + Config.mapOffsetY]);
    spherical[0] = THREE.Math.degToRad(spherical[0]);
    spherical[1] = THREE.Math.degToRad(spherical[1]);
    worldMap.countries[i].center3D.x = -1 * Config.globeRadius * Math.cos(spherical[0]) * Math.cos(spherical[1]);
    worldMap.countries[i].center3D.y = Config.globeRadius * Math.sin(spherical[1]);
    worldMap.countries[i].center3D.z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]); */
    //worldMap.countries[i].center3D.applyMatrix4(m);


    // 3D points meshes (for showing country border on hover):
    worldMap.countries[i].border3D = new THREE.Object3D();
    for(s = 0; s < worldMap.countries[i].shapes.length; s++) {
      pointsGeometry = worldMap.countries[i].shapes[s].createPointsGeometry();
      for(k = 0; k < pointsGeometry.vertices.length; k++) {
        spherical = worldMap.geo.projection.invert([pointsGeometry.vertices[k].x, pointsGeometry.vertices[k].y]);

        spherical[0] = THREE.Math.degToRad(spherical[0]);
        spherical[1] = THREE.Math.degToRad(spherical[1]);

        pointsGeometry.vertices[k].x = -1 * Config.globeRadius * Math.cos(spherical[0]) * Math.cos(spherical[1]);
        pointsGeometry.vertices[k].y = Config.globeRadius * Math.sin(spherical[1]);
        pointsGeometry.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);

        pointsGeometry.vertices[k].multiplyScalar(1.001); // 1.004
      }
      worldMap.countries[i].border3D.add(new THREE.Line( pointsGeometry, Config.materialCountryBorder ));
    }
    // rotate and bake transform into vertices:
    //worldMap.countries[i].border3D.applyMatrix(m);


    // 3D points meshes (for disputed country border, always visible):
    /* if(worldMap.countries[i].disputed) {
      worldMap.countries[i].borderDisputed3D = new THREE.Object3D();
      for(s = 0; s < worldMap.countries[i].shapes.length; s++) {
        pointsGeometry = worldMap.countries[i].shapes[s].createPointsGeometry();
        for(k = 0; k < pointsGeometry.vertices.length; k++) {
          spherical = worldMap.geo.projection.invert([pointsGeometry.vertices[k].x, pointsGeometry.vertices[k].y]);

          spherical[0] = THREE.Math.degToRad(spherical[0]);
          spherical[1] = THREE.Math.degToRad(spherical[1]);

          pointsGeometry.vertices[k].x = Config.globeRadius * Math.cos(spherical[0]) * Math.cos(spherical[1]);
          pointsGeometry.vertices[k].y = -Config.globeRadius * Math.sin(spherical[1]);
          pointsGeometry.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);

          pointsGeometry.vertices[k].multiplyScalar(1.0015); // 1.004
        }
        worldMap.countries[i].borderDisputed3D.add(new THREE.Line( pointsGeometry, Config.materialCountryBorderDisputed ));
      }
      // rotate and bake transform into vertices:
      worldMap.countries[i].borderDisputed3D.applyMatrix(m);
    } */

    //


    worldMap.countries[i].mesh = new THREE.Mesh(worldMap.countries[i].geometry, Config.materialCountryDefault); // worldMap.countries[i].material // worldMap.materialCountryDefault
    worldMap.countries[i].mesh.name = worldMap.countries[i].name;
    worldMap.countries[i].mesh.countryObject = worldMap.countries[i];
    if(!Config.usesWebGL) {
      worldMap.countries[i].mesh.material = new THREE.MeshPhongMaterial({
        color: new THREE.Color(0x777777),
        transparent: false,
        wireframe: false,
        shading: THREE.SmoothShading,
        side: THREE.DoubleSide,
        overdraw: true
      });
    }

    worldMap.countriesObject3D.add(worldMap.countries[i].mesh);

    if(i == 0) {
      /* log(worldMap.countries[i]);
      let marker = createMarkerLatLon(21.91672, 291.86599);
      marker.visible = true;
      worldMap.scene.add(marker); */
      /* var test = new THREE.Mesh( new THREE.SphereGeometry( 150, 64, 64 ), Config.materialSphere );
      log(worldMap.scene.worldToLocal(worldMap.countries[i].center3D));
      test.position.set(worldMap.sphere.worldToLocal(worldMap.countries[i].center3D));  
      worldMap.globe.add(test); */
    }

  } // for worldMap.countries.length initial geometry creation end

  //worldMap.globe.applyMatrix(m);

  if(!Config.usesWebGL) {
    worldMap.scene.add(worldMap.countriesObject3D);
  }

  //log('Geometry: ' + worldMap.trianglesNumTotal + ' triangles total');

  var scaleStart = 0.0;
  worldMap.countriesObject3D.scale.set(scaleStart, scaleStart, scaleStart);
  worldMap.countriesObject3D.rotation.y = -Math.PI * 6.0;
  worldMap.sphere.scale.set(scaleStart, scaleStart, scaleStart);
  worldMap.sphere.rotation.y = -Math.PI * 6.0;
  worldMap.globe.rotation.y = -Math.PI * 6.0;

  //log('Geometry: creating meshes took ' + (Date.now() - start) + ' ms');
};


export function updateCountriesGeometry(worldMap, computeFaceNormals) {
  // log('Geometry.updateCountriesGeometry()');

  var i;
  var k;
  for(i = 0; i < worldMap.countries.length; i++) {
    for(k = 0; k < worldMap.countries[i].geometry.vertices.length; k++) {
      worldMap.countries[i].geometry.vertices[k].copy(worldMap.countries[i].geometry2D.vertices[k]);
      worldMap.countries[i].geometry.vertices[k].mix(worldMap.countries[i].geometry3D.vertices[k], worldMap.animationProps.interpolatePos);
    }
    // worldMap.countries[i].geometry.verticesNeedUpdate = true; // required to update mesh, also for picking to work

    /*
    worldMap.countries[i].geometry.normalsNeedUpdate = true;
    worldMap.countries[i].geometry.uvsNeedUpdate = true;
    worldMap.countries[i].geometry.elementsNeedUpdate = true;
    worldMap.countries[i].geometry.tangentsNeedUpdate = true;
    worldMap.countries[i].geometry.lineDistancesNeedUpdate = true;
    worldMap.countries[i].geometry.colorsNeedUpdate = true;
    worldMap.countries[i].geometry.buffersNeedUpdate = true;
    */

    worldMap.countries[i].geometry.computeBoundingSphere(); // required for picking to work after updating vertices
    if(computeFaceNormals) worldMap.countries[i].geometry.computeFaceNormals(); // required for shading to look correct

  }

  // transform sphere:
  if(worldMap.sphere) {
    for(k = 0; k < worldMap.sphere.geometry.vertices.length; k++) {
      worldMap.sphere.geometry.vertices[k].copy(worldMap.sphereGeometry2D.vertices[k]);
      worldMap.sphere.geometry.vertices[k].mix(worldMap.sphereGeometry3D.vertices[k], worldMap.animationProps.interpolatePos * worldMap.animationProps.interpolatePos);
    }
    worldMap.sphere.geometry.verticesNeedUpdate = true; // required to update mesh

    worldMap.sphere.geometry.computeBoundingSphere(); // required for picking to work after updating vertices
    worldMap.sphere.geometry.computeFaceNormals(); // required for shading to look correct
  }
};


export function createCountriesBufferGeometry(worldMap) {
  worldMap.bufferGeometry = new THREE.BufferGeometry();

  var positions = new Float32Array( worldMap.trianglesNumTotal * 3 * 3 );
  var normals = new Float32Array( worldMap.trianglesNumTotal * 3 * 3 );
  var colors = new Float32Array( worldMap.trianglesNumTotal * 3 * 3 );

  var color = new THREE.Color();
  color.set(Config.colorCountryDefault);

  var index = 0;
  var i, f;
  for(i = 0; i < worldMap.countries.length; i++) {
    var vertices = worldMap.countries[i].geometry.vertices;

    for(f = 0; f < worldMap.countries[i].geometry.faces.length; f++) {
      var face = worldMap.countries[i].geometry.faces[f];

      // positions

      positions[ index ] = vertices[ face.a ].x;
      positions[ index + 1 ] = vertices[ face.a ].y;
      positions[ index + 2 ] = vertices[ face.a ].z;

      positions[ index + 3 ] = vertices[ face.b ].x;
      positions[ index + 4 ] = vertices[ face.b ].y;
      positions[ index + 5 ] = vertices[ face.b ].z;

      positions[ index + 6 ] = vertices[ face.c ].x;
      positions[ index + 7 ] = vertices[ face.c ].y;
      positions[ index + 8 ] = vertices[ face.c ].z;

      // normals

      normals[ index ] = face.normal.x;
      normals[ index + 1 ] = face.normal.y;
      normals[ index + 2 ] = face.normal.z;

      normals[ index + 3 ] = face.normal.x;
      normals[ index + 4 ] = face.normal.y;
      normals[ index + 5 ] = face.normal.z;

      normals[ index + 6 ] = face.normal.x;
      normals[ index + 7 ] = face.normal.y;
      normals[ index + 8 ] = face.normal.z;

      // colors

      colors[ index ] = color.r;
      colors[ index + 1 ] = color.g;
      colors[ index + 2 ] = color.b;

      colors[ index + 3 ] = color.r;
      colors[ index + 4 ] = color.g;
      colors[ index + 5 ] = color.b;

      colors[ index + 6 ] = color.r;
      colors[ index + 7 ] = color.g;
      colors[ index + 8 ] = color.b;

      index += 9;

    }
  } // for worldMap.countries.length buffer geometry creation end

  worldMap.bufferGeometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
  worldMap.bufferGeometry.addAttribute( 'normal', new THREE.BufferAttribute( normals, 3 ) );
  worldMap.bufferGeometry.addAttribute( 'color', new THREE.BufferAttribute( colors, 3 ) );

  worldMap.bufferGeometry.verticesNeedUpdate = true;
  worldMap.bufferGeometry.computeBoundingSphere();
  // worldMap.bufferGeometry.computeVertexNormals();

  var mesh = new THREE.Mesh( worldMap.bufferGeometry, Config.materialMap );
  worldMap.scene.add( mesh );

};


export function updateCountriesBufferGeometry(worldMap) {
  // log('Geometry.updateCountriesBufferGeometry()');

  var positions = worldMap.bufferGeometry.getAttribute( 'position' ).array;
  var normals = worldMap.bufferGeometry.getAttribute( 'normal' ).array;
  var colors = worldMap.bufferGeometry.getAttribute( 'color' ).array;

  var m = new THREE.Matrix4();
  var m1 = new THREE.Matrix4();
  var m2 = new THREE.Matrix4();
  m1.makeRotationY( worldMap.countriesObject3D.rotation.y );
  m2.makeScale( worldMap.countriesObject3D.scale.x, worldMap.countriesObject3D.scale.y, worldMap.countriesObject3D.scale.z );
  m.multiplyMatrices( m1, m2 );

  var color = new THREE.Color();
  var v = new THREE.Vector3();

  var index = 0;
  var i, f;
  for(i = 0; i < worldMap.countries.length; i++) {
    var vertices = worldMap.countries[i].geometry.vertices;

    // log( worldMap.countries[i].name );
    // log( worldMap.countries[i].visa_required );

    color.set(worldMap.countries[i].color);

    for(f = 0; f < worldMap.countries[i].geometry.faces.length; f++) {
      var face = worldMap.countries[i].geometry.faces[f];

      // positions

      v.copy( vertices[ face.a ] );
      v.applyMatrix4(m);

      positions[ index ] = v.x;
      positions[ index + 1 ] = v.y;
      positions[ index + 2 ] = v.z;

      v.copy( vertices[ face.b ] );
      v.applyMatrix4(m);

      positions[ index + 3 ] = v.x;
      positions[ index + 4 ] = v.y;
      positions[ index + 5 ] = v.z;

      v.copy( vertices[ face.c ] );
      v.applyMatrix4(m);

      positions[ index + 6 ] = v.x;
      positions[ index + 7 ] = v.y;
      positions[ index + 8 ] = v.z;

      // normals

      normals[ index ] = face.normal.x;
      normals[ index + 1 ] = face.normal.y;
      normals[ index + 2 ] = face.normal.z;

      normals[ index + 3 ] = face.normal.x;
      normals[ index + 4 ] = face.normal.y;
      normals[ index + 5 ] = face.normal.z;

      normals[ index + 6 ] = face.normal.x;
      normals[ index + 7 ] = face.normal.y;
      normals[ index + 8 ] = face.normal.z;

      // colors

      colors[ index ] = color.r;
      colors[ index + 1 ] = color.g;
      colors[ index + 2 ] = color.b;

      colors[ index + 3 ] = color.r;
      colors[ index + 4 ] = color.g;
      colors[ index + 5 ] = color.b;

      colors[ index + 6 ] = color.r;
      colors[ index + 7 ] = color.g;
      colors[ index + 8 ] = color.b;

      index += 9;

    }
  } // for worldMap.countries.length buffer geometry update end

  worldMap.bufferGeometry.attributes.position.needsUpdate = true;
  worldMap.bufferGeometry.attributes.normal.needsUpdate = true;
  worldMap.bufferGeometry.attributes.color.needsUpdate = true;

  // worldMap.bufferGeometry.colorsNeedUpdate = true;
  worldMap.bufferGeometry.computeBoundingSphere();
  // worldMap.bufferGeometry.computeVertexNormals();

};


export function updateCountriesBufferGeometryColors(worldMap) {
  // log('Geometry.updateCountriesBufferGeometryColors()');

  var colors = worldMap.bufferGeometry.getAttribute( 'color' ).array;

  var color = new THREE.Color();

  var index = 0;
  var i, f;
  for(i = 0; i < worldMap.countries.length; i++) {
    color.set(worldMap.countries[i].color);

    for(f = 0; f < worldMap.countries[i].geometry.faces.length; f++) {
      colors[ index ] = color.r;
      colors[ index + 1 ] = color.g;
      colors[ index + 2 ] = color.b;

      colors[ index + 3 ] = color.r;
      colors[ index + 4 ] = color.g;
      colors[ index + 5 ] = color.b;

      colors[ index + 6 ] = color.r;
      colors[ index + 7 ] = color.g;
      colors[ index + 8 ] = color.b;

      index += 9;

    }
  } // for worldMap.countries.length buffer geometry update end

  worldMap.bufferGeometry.attributes.color.needsUpdate = true;

};


export function createSphere(worldMap) {
  worldMap.sphere = new THREE.Mesh( new THREE.PlaneGeometry( 700, 700, 64, 64 ), Config.materialSphere );
  worldMap.sphere.name = 'sphere';
  worldMap.scene.add( worldMap.sphere );
  worldMap.sphere.visible = Config.sphereVisible;

  worldMap.sphereGeometry2D = worldMap.sphere.geometry.clone();
  var k;
  for(k = 0; k < worldMap.sphereGeometry2D.vertices.length; k++) {
    worldMap.sphereGeometry2D.vertices[k].x -= 20;
    worldMap.sphereGeometry2D.vertices[k].y -= 90;
    worldMap.sphereGeometry2D.vertices[k].z -= Config.extrudeDepth * 2.0;
  }

  worldMap.sphereGeometry3D = worldMap.sphere.geometry.clone();

  for(k = 0; k < worldMap.sphere.geometry.vertices.length; k++) {
    var spherical = worldMap.geo.projection.invert([ -worldMap.sphere.geometry.vertices[k].x, worldMap.sphere.geometry.vertices[k].y * 2.0 + 250 ]); //  * 2.0 + 260

    spherical[0] = THREE.Math.degToRad(spherical[0]);
    spherical[1] = THREE.Math.degToRad(spherical[1]);

    worldMap.sphereGeometry3D.vertices[k].x = (Config.globeRadius - 1) * Math.cos(spherical[0]) * Math.cos(spherical[1]);
    worldMap.sphereGeometry3D.vertices[k].y = -(Config.globeRadius - 1) * Math.sin(spherical[1]);
    worldMap.sphereGeometry3D.vertices[k].z = (Config.globeRadius - 1) * Math.sin(spherical[0]) * Math.cos(spherical[1]);

    /*
    if(worldMap.sphereGeometry3D.vertices[k].z < 0.0) {
      worldMap.sphereGeometry3D.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);
      //worldMap.sphereGeometry3D.vertices[k].multiplyScalar(0.5);
    } else {
      worldMap.sphereGeometry3D.vertices[k].z = Config.globeRadius * Math.sin(spherical[0]) * Math.cos(spherical[1]);
      //worldMap.sphereGeometry3D.vertices[k].multiplyScalar(1.04);
    }
    */

  }
  // rotate and bake transform into vertices:
  var m = new THREE.Matrix4();
  m.makeRotationX( THREE.Math.degToRad(45) );
  worldMap.sphereGeometry3D.applyMatrix(m);

  worldMap.globe = new THREE.Mesh( new THREE.SphereGeometry( 179, 64, 64 ), Config.materialSphere );
  worldMap.globe.scale.set(0.0, 0.0, 0.0);  
  worldMap.scene.add(worldMap.globe);
};


export function getIntersects(worldMap, mouse) {
  var vector = new THREE.Vector3();
  vector.copy(mouse);
  vector.unproject( worldMap.camera );

  worldMap.raycaster.set( worldMap.camera.position, vector.sub( worldMap.camera.position ).normalize() );

  var intersects = worldMap.raycaster.intersectObjects( worldMap.countriesObject3D.children );
  intersects.sort( function( a, b ) { return a.distance - b.distance; } );

  return intersects;
};

export function getIntersectsPin(worldMap, mouse) {
  var vector = new THREE.Vector3();
  vector.copy(mouse);
  vector.unproject( worldMap.camera );

  worldMap.raycaster.set( worldMap.camera.position, vector.sub( worldMap.camera.position ).normalize() );

  var intersects = worldMap.raycaster.intersectObjects( worldMap.scene.children, true );
  intersects.sort( function( a, b ) { return a.distance - b.distance; } );

  return intersects;
};


export function createLines(worldMap) {
  // log('Geometry.createLines()');

  if(worldMap.mode !== 'destinations' && worldMap.mode !== 'sources') {
    return;
  }

  if(worldMap.selectedCountry || worldMap.selectedDestinationCountry) {
    var points2D;
    var points3D;
    var line;
    var c;

    deleteLinesObject(worldMap);

    worldMap.linesObject = new THREE.Object3D();
    worldMap.scene.add(worldMap.linesObject);

    if(worldMap.selectedCountry && worldMap.selectedDestinationCountry) {
      points2D = [];
      points3D = [];

      if(worldMap.mode === 'destinations') {
        points2D.push( worldMap.selectedCountry.center2D );
        points2D.push( worldMap.selectedDestinationCountry.center2D );

        points3D.push( worldMap.selectedCountry.center3D );
        points3D.push( worldMap.selectedDestinationCountry.center3D );
      } else {
        points2D.push( worldMap.selectedDestinationCountry.center2D );
        points2D.push( worldMap.selectedCountry.center2D );

        points3D.push( worldMap.selectedDestinationCountry.center3D );
        points3D.push( worldMap.selectedCountry.center3D );
      }

      worldMap.selectedDestinationCountry.spline2D = new THREE.Spline( points2D );
      worldMap.selectedDestinationCountry.spline3D = new THREE.Spline( points3D );

      worldMap.selectedDestinationCountry.splineLength = points2D[0].distanceTo(points2D[1]);
      worldMap.selectedDestinationCountry.splineHeight = worldMap.selectedDestinationCountry.splineLength * 0.25;
      worldMap.selectedDestinationCountry.geometrySpline = new THREE.Geometry();

      line = new THREE.Line( worldMap.selectedDestinationCountry.geometrySpline, CountryDataHelpers.getLineMaterial(worldMap.selectedDestinationCountry), THREE.LineStrip );
      worldMap.linesObject.add(line);

    } else if(worldMap.selectedCountry && !worldMap.selectedDestinationCountry) {
      if(worldMap.mode === 'destinations') {
        for(c = 0; c < worldMap.countries.length; c++) {
          if(worldMap.countries[c].visa_required === 'no' || worldMap.countries[c].visa_required === 'on-arrival' || worldMap.countries[c].visa_required === 'free-eu') {
            points2D = [];
            points2D.push( worldMap.selectedCountry.center2D );
            points2D.push( worldMap.countries[c].center2D );
            worldMap.countries[c].spline2D = new THREE.Spline( points2D );

            points3D = [];
            points3D.push( worldMap.selectedCountry.center3D );
            points3D.push( worldMap.countries[c].center3D );
            worldMap.countries[c].spline3D = new THREE.Spline( points3D );

            worldMap.countries[c].splineLength = points2D[0].distanceTo(points2D[1]);
            worldMap.countries[c].splineHeight = worldMap.countries[c].splineLength * 0.25;
            worldMap.countries[c].geometrySpline = new THREE.Geometry();

            line = new THREE.Line( worldMap.countries[c].geometrySpline, CountryDataHelpers.getLineMaterial(worldMap.countries[c]), THREE.LineStrip );
            worldMap.linesObject.add(line);
          }
        }
      }

    } else if(!worldMap.selectedCountry && worldMap.selectedDestinationCountry) {
      if(worldMap.mode === 'sources') {
        for(c = 0; c < worldMap.countries.length; c++) {
          if(worldMap.countries[c].visa_required === 'no' || worldMap.countries[c].visa_required === 'on-arrival' || worldMap.countries[c].visa_required === 'free-eu') {
            points2D = [];
            points2D.push( worldMap.selectedDestinationCountry.center2D );
            points2D.push( worldMap.countries[c].center2D );
            worldMap.countries[c].spline2D = new THREE.Spline( points2D );

            points3D = [];
            points3D.push( worldMap.selectedDestinationCountry.center3D );
            points3D.push( worldMap.countries[c].center3D );
            worldMap.countries[c].spline3D = new THREE.Spline( points3D );

            worldMap.countries[c].splineLength = points2D[0].distanceTo(points2D[1]);
            worldMap.countries[c].splineHeight = worldMap.countries[c].splineLength * 0.25;
            worldMap.countries[c].geometrySpline = new THREE.Geometry();

            line = new THREE.Line( worldMap.countries[c].geometrySpline, CountryDataHelpers.getLineMaterial(worldMap.countries[c]), THREE.LineStrip );
            worldMap.linesObject.add(line);
          }
        }
      }
    }

    worldMap.animationProps.lineAnimatePos = 0;
    worldMap.animationProps.lineAnimateOffset = 0;

    worldMap.tweenLines = new TWEEN.Tween(worldMap.animationProps)
      .to({lineAnimatePos: 1}, Config.lineAnimateDuration)
      .onStart(function() {
      })
      .onUpdate(function(time) {
        // worldMap.updateLines(time);
      })
      .easing(TWEEN.Easing.Sinusoidal.Out)
      .start();
  }

};


export function updateLines(worldMap) {
  // log('Geometry.updateLines()');

  worldMap.animationProps.lineAnimateOffset += Config.lineAnimateSpeed * worldMap.clock.getDelta();
  worldMap.animationProps.lineAnimateOffset %= Config.lineDashOffsetLimit;

  if(worldMap.selectedCountry || worldMap.selectedDestinationCountry) {

    for(var c = 0; c < worldMap.countries.length; c++) {
      var offset = worldMap.animationProps.lineAnimateOffset / worldMap.countries[c].splineLength;

      // if(worldMap.countries[c].visa_required === 'no' || worldMap.countries[c].visa_required === 'on-arrival' || worldMap.countries[c].visa_required === 'free-eu') {
      if(worldMap.countries[c].geometrySpline) {
        var subdivisions = 30;
        for(var i = 0; i < subdivisions; i++) {
          var index;
          index = i / subdivisions * worldMap.animationProps.lineAnimatePos;
          index += offset;
          if(worldMap.mode === 'sources') {
            index = 1 - index;
          }
          index = Math.min(index, 1);
          index = Math.max(index, 0);

          var position2D = worldMap.countries[c].spline2D.getPoint( index );
          var position3D = worldMap.countries[c].spline3D.getPoint( index );

          var z = 0;

          if(index < 0.5) {
            z = TWEEN.Easing.Sinusoidal.Out( index * 2 ) * worldMap.countries[c].splineHeight;
          } else {
            z = TWEEN.Easing.Sinusoidal.Out( 1 - (index - 0.5) * 2 ) * worldMap.countries[c].splineHeight;
          }

          worldMap.countries[c].geometrySpline.vertices[ i ] = new THREE.Vector3( position2D.x, position2D.y, position2D.z );
          worldMap.countries[c].geometrySpline.vertices[ i ].z += z;

          var v3D = new THREE.Vector3( position3D.x, position3D.y, position3D.z );
          v3D.setLength(Config.globeRadius + z);

          worldMap.countries[c].geometrySpline.vertices[ i ].lerp(v3D, worldMap.animationProps.interpolatePos);

        }
        worldMap.countries[c].geometrySpline.verticesNeedUpdate = true;
        worldMap.countries[c].geometrySpline.lineDistancesNeedUpdate = true;
        worldMap.countries[c].geometrySpline.computeLineDistances();
      }
    }
  }
};


export function deleteLinesObject(worldMap) {
  // log('Geometry.deleteLinesObject()');

  if(worldMap.linesObject) {
    worldMap.scene.remove(worldMap.linesObject);
    worldMap.linesObject = null;
  }
};


export function toScreenXY(camera, pos3D) {
  var v = pos3D.project( camera );
  var percX = (v.x + 1) / 2;
  var percY = (-v.y + 1) / 2;

  var left = percX * window.innerWidth;
  var top = percY * window.innerHeight;

  return new THREE.Vector2(left, top);
};
